<template>
  <a-menu-item key="i18nConfig" @click="showProjectI18nModal">
    <GlobalOutlined />&nbsp;多語系設定&nbsp;
  </a-menu-item>
  <a-modal v-model:open="isOpen" width="650px" title="專案多語系設定"
      :maskClosable="isMaskClosable" :closable="isMaskClosable" :cancelButtonProps="cancelButtonProps"
      :confirm-loading="isSavingProject" okText="儲存" cancelText="取消" @cancel="cancelUpdateI18nMessage" @ok="saveI18nMessages">
    <a-divider />
    <a-space direction="vertical">
      <a-space-compact>
        <a-tag :bordered="false" color="volcano">專案編號</a-tag>{{ formState.projectNo }}
      </a-space-compact>
      <a-space-compact>
        <a-tag :bordered="false" color="volcano">專案名稱</a-tag>{{ formState.projectName }}
      </a-space-compact>
      <a-space-compact>
        <a-tag :bordered="false" color="volcano">客戶名稱</a-tag>{{ formState.companyName }}
      </a-space-compact>
    </a-space>
    <a-divider />
    <a-form name="basic" :label-col="{ span: 7 }" :wrapper-col="{ span: 12 }">
      <a-form-item label="問卷抬頭顯示名稱">
        <I18nMessageModal title="多語系設定-問卷抬頭顯示名稱" 
            :message="formState.questionnaireTitle" 
            @update-complete="updateQuestTitleComplete" />
      </a-form-item>
      <a-form-item label="外國人填寫資訊提示">
        <I18nMessageModal title="多語系設定-外國人填寫資訊提示" 
            :message="formState.foreignerInputTip" 
            @update-complete="updateForeignerInputTipComplete" />
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script setup>
import { GlobalOutlined } from "@ant-design/icons-vue";
import { ref, defineEmits, defineProps, reactive } from 'vue';

import I18nMessageModal from '../common/I18nMessageModal.vue';

import common from "@/common";
import config from "@/config";

const props = defineProps(['project']);
const emit = defineEmits(['cancel', 'submit-success']);

const project = ref();
const isOpen = ref(false);
const isMaskClosable = ref(false);
const isSavingProject = ref(false);
const formState = reactive({});
const cancelButtonProps = ref({
  disabled: isSavingProject
});

const initProjectI18nModal = () => {
  project.value = props.project;
  formState.projectNo = props.project.projectNo;
  formState.projectName = props.project.projectName;
  formState.companyName = props.project.companyName;
  formState.projectUrl = props.project.url;
  formState.questionnaireTitle = props.project.projectConfig.questionnaireTitle;
  formState.foreignerInputTip = props.project.projectConfig.foreignerInputTip;
}

const showProjectI18nModal = () => {
  resetFormState();
  isOpen.value = true;
  initProjectI18nModal();
}

const cancelUpdateI18nMessage = () => {
  isOpen.value = false;
  emit('cancel');
}

const saveI18nMessages = () => {
  isSavingProject.value = true;
  common.postRequest(config.mgmtSaveProjectI18nMessage, formState, 
    () => {
      isOpen.value = false;
      isSavingProject.value = false;
      emit('submit-success', project.value, formState.questionnaireTitle, formState.foreignerInputTip);
    }, () => {
      isSavingProject.value = false;
    });
}

const resetFormState = () => {
  formState.projectUrl = '';
  formState.questionnaireTitle = null;
  formState.foreignerInputTip = null;
}

const updateQuestTitleComplete = (messages) => {
  formState.questionnaireTitle.messageZhTw = messages.messageZhTw;
  formState.questionnaireTitle.messageEnUs = messages.messageEnUs;
  formState.questionnaireTitle.messageThTh = messages.messageThTh;
  formState.questionnaireTitle.messageViVn = messages.messageViVn;
  formState.questionnaireTitle.messageIdId = messages.messageIdId;
  formState.questionnaireTitle.messageJaJp = messages.messageJaJp;
}

const updateForeignerInputTipComplete = (messages) => {
  formState.foreignerInputTip.messageZhTw = messages.messageZhTw;
  formState.foreignerInputTip.messageEnUs = messages.messageEnUs;
  formState.foreignerInputTip.messageThTh = messages.messageThTh;
  formState.foreignerInputTip.messageViVn = messages.messageViVn;
  formState.foreignerInputTip.messageIdId = messages.messageIdId;
  formState.foreignerInputTip.messageJaJp = messages.messageJaJp;
}

</script>
<style scoped>
button,
span {
  display: inline-flex;
  align-items: center;
}
</style>